import React from 'react';
import { motion } from 'framer-motion';
import { painPoints } from '../data/painPoints';
export function PainPoints() {
  return <section className="py-24 px-4 bg-white" data-id="element-184" data-mp="2lmspylv9v6kb">
      <div className="max-w-4xl mx-auto" data-id="element-185" data-mp="26yfudq03jpqc">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="text-center mb-12" data-id="element-186" data-mp="26xmsb2c31oej">
          <h2 className="text-3xl md:text-4xl font-serif font-bold mb-6 text-navy" data-id="element-187" data-mp="21z37545bcgn8">
            💬 A Practice Night That Feels Far Too Familiar
          </h2>
          <p className="text-lg text-slate leading-relaxed bg-mist p-6 rounded-2xl border border-mist-dark shadow-sm text-left" data-id="element-188" data-mp="1o1eirmc1erdf">
            Practice is tomorrow. And you are still trying to figure out what to teach.
            Searching for another drill. Trying to build a progression that actually makes
            sense. Repeating the same techniques because they are the ones you remember
            fastest. Wondering whether you should work neutral, top, bottom, conditioning or
            just let everyone wrestle live.
            <br data-id="element-189" data-mp="27sz040tlvktu" />
            <br data-id="element-190" data-mp="27tidd48b9l1j" />
            <span className="text-navy font-medium" data-id="element-191" data-mp="27rxfp5qp9lzg">
              Not because you don&apos;t know wrestling. You already know wrestling.
            </span>{' '}
            The problem is that nobody gave you a complete, organized, ready-to-coach system.
            So you keep building practices from scratch, and the time you should be spending
            coaching, recovering or focusing on your athletes gets consumed by planning.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-192" data-mp="1k2wea2gabb3o">
          <h3 className="text-xl font-bold text-navy mb-8 text-center" data-id="element-193" data-mp="2vhje3qz8zx6e">
            The Real Cost of Not Having the Right Coaching System
          </h3>
          <div className="overflow-hidden rounded-xl border border-mist-dark bg-white shadow-sm" data-id="element-194" data-mp="1t7ho08jnmk37">
            <div className="hidden sm:grid grid-cols-2 bg-navy text-xs uppercase tracking-wider font-bold text-white" data-id="element-195" data-mp="1y62sik5xvpxg">
              <p className="px-5 py-3" data-id="element-196" data-mp="274o600wk0erd">The Problem</p>
              <p className="px-5 py-3 border-l border-white/20" data-id="element-197" data-mp="2744yzf8fzas4">The Real Impact</p>
            </div>
            {painPoints.map((point, index) => <motion.div key={point.problem} initial={{
            opacity: 0,
            x: -12
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.25,
            delay: index * 0.05,
            ease: [0.23, 1, 0.32, 1]
          }} className="grid sm:grid-cols-2 border-t first:border-t-0 border-mist-dark" data-id="element-198" data-mp="1efqzev1pg6eg" data-mpi={index}>
                <p className="px-5 py-4 text-navy text-sm leading-relaxed" data-id="element-199" data-mp="vozjfan7phr3">
                  <span className="mr-2 text-alert font-bold" data-id="element-200" data-mp="o68h792wphoq">✕</span>
                  {point.problem}
                </p>
                <p className="px-5 pb-4 sm:py-4 text-slate text-sm leading-relaxed sm:border-l border-mist-dark" data-id="element-201" data-mp="j6vrmgknhwig">
                  {point.impact}
                </p>
              </motion.div>)}
          </div>

          <div className="text-center mt-12 pt-8 border-t border-mist-dark" data-id="element-202" data-mp="a5p961yfybmk">
            <p className="text-2xl font-serif font-bold text-navy" data-id="element-203" data-mp="57no5bhgg28g">
              Stop giving away your preparation time.{' '}
              <span className="text-gold-solid" data-id="element-204" data-mp="f31ctwyupef">Your coaching knowledge is already there.</span>
            </p>
            <p className="text-xl mt-4 text-slate" data-id="element-205" data-mp="3rn8fxjax4fzt">
              Build an entire season of better wrestling practices.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}